import { useEffect, useState } from "react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import BookingDialog from "@/components/site/BookingDialog";
import WorkshopDialog from "@/components/ateliers/WorkshopDialog";
import NotifyDialog from "@/components/ateliers/NotifyDialog";
import CalHero from "@/components/calendar/CalHero";
import CalIntro from "@/components/calendar/CalIntro";
import CalCalendar from "@/components/calendar/CalCalendar";
import CalScarcity from "@/components/calendar/CalScarcity";
import CalFinalCTA from "@/components/calendar/CalFinalCTA";
import CalInfoReminder from "@/components/calendar/CalInfoReminder";
import { fetchWorkshops } from "@/lib/api";

export default function CalendrierPage() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [workshopOpen, setWorkshopOpen] = useState(false);
  const [notifyOpen, setNotifyOpen] = useState(false);
  const [selectedWorkshop, setSelectedWorkshop] = useState(null);
  const [workshops, setWorkshops] = useState([]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    fetchWorkshops()
      .then(setWorkshops)
      .catch(() => setWorkshops([]));
  }, []);

  const openRegister = (w = null) => {
    setSelectedWorkshop(w);
    setWorkshopOpen(true);
  };

  return (
    <div className="min-h-screen bg-[#FAF7F8] text-[#1E1E2A]" data-testid="calendrier-page">
      <Navbar onBookingClick={() => setBookingOpen(true)} />
      <main>
        <CalHero />
        <CalIntro />
        <CalCalendar workshops={workshops} onRegister={openRegister} />
        <CalScarcity />
        <CalFinalCTA
          onRegister={() => openRegister(null)}
          onNotify={() => setNotifyOpen(true)}
        />
        <CalInfoReminder />
      </main>
      <Footer />
      <BookingDialog open={bookingOpen} onOpenChange={setBookingOpen} />
      <WorkshopDialog
        open={workshopOpen}
        onOpenChange={setWorkshopOpen}
        workshops={workshops}
        preselected={selectedWorkshop}
      />
      <NotifyDialog open={notifyOpen} onOpenChange={setNotifyOpen} />
    </div>
  );
}
